module.exports = __webpack_public_path__ + "static/media/shed-large.3a85cb32.png";